const FIELD_BASE =
	'w-full border bg-white text-sm text-text placeholder:text-bgBase-700 shadow-field transition-[border-color,box-shadow] focus:outline-none disabled:cursor-not-allowed disabled:bg-bgBase-300 disabled:text-bgBase-800';

const FIELD_DEFAULT = 'border-bgBase-500 focus:border-primary-300 focus:shadow-field-focus';
const FIELD_ERROR = 'border-warning-500 focus:border-warning-500';

export function fieldClasses(shapeClasses, error, className) {
	return [FIELD_BASE, shapeClasses, error ? FIELD_ERROR : FIELD_DEFAULT, className].filter(Boolean).join(' ');
}
